import i18n, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getBaseHref } from './bootstrap';
import { store } from './store/store';
import { setLanguage } from '@casops/store/slices/authSlice';

export const supportedLanguages = ['en', 'es', 'pt'];
export const fallbackLanguage = 'en';
const TranslationNamespaceBackend = 'backend';

export const isLanguageSetting = (value: string): value is string => {
  return Object.values(supportedLanguages).includes(value);
};

const version = process.env.NX_PUBLIC_MAGIC_VERSION ?? '1';

const baseHrefRaw = getBaseHref();
const baseHref = baseHrefRaw.endsWith('/') ? baseHrefRaw : `${baseHrefRaw}/`;

const initOptions: InitOptions = {
  ns: ['casops'], //, TranslationNamespaceBackend],
  defaultNS: 'casops',
  fallbackNS: 'casops',
  load: 'all',
  fallbackLng: fallbackLanguage,
  supportedLngs: supportedLanguages,
  interpolation: {
    escapeValue: false,
  },
  backend: {
    loadPath: (lngs: string[], namespaces: string[]) => {
      if (namespaces.length === 1 && namespaces[0] === TranslationNamespaceBackend) {
        return `${baseHref}api/resx/locales/{{ns}}/{{lng}}/translation.json?version=${version}`;
      }

      return `${baseHref}resx/locales/{{ns}}/{{lng}}/translation.json?version=${version}`;
    },
  },

  detection: {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'language',
    lookupSessionStorage: 'language',
  },
};

i18n.use(LanguageDetector).use(Backend).use(initReactI18next);

i18n.on('languageChanged', lng => {
  store.dispatch(setLanguage(lng));
});

i18n.init(initOptions);

export default i18n;
